export default __webpack_public_path__ + "static/media/16.63101a1e.jpg";